import { AppointmentSlot } from "../models/appointment-slot";
import { BaseDecisionTreeViewerApi } from "./base";

export class AppointmentSlotApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ model: AppointmentSlot, baseURL: "/ehr_appointment_slots" });
  }
}

let api;

export const useAppointmentSlotApi = () => {
  api ??= new AppointmentSlotApi();

  return {
    find: async (id) => api.get(id.toString()),
  };
};
